import { AsyncPipe, NgClass, NgIf } from "@angular/common";
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { TriStateCheckBoxComponent, ClickFilterComponent } from '@myapp/features/widgets/components';
import { UiWindowService } from '@myapp/modules/fwcore/services';
import { ButtonModule } from "@progress/kendo-angular-buttons";
import { DatePickerModule } from "@progress/kendo-angular-dateinputs";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { FormFieldModule, NumericTextBoxModule, TextAreaModule, TextBoxModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { TabStripModule } from "@progress/kendo-angular-layout";
import { Company, License } from "../../../models";

@Component({
  selector: 'app-license-grid-editor',
  templateUrl: './license-grid-editor.component.html',
  styleUrls: ['./license-grid-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf, DialogModule, FormsModule, ReactiveFormsModule, TabStripModule, FormFieldModule, LabelModule
    , TextBoxModule, DropDownListModule, TriStateCheckBoxComponent, ClickFilterComponent, NgClass, DatePickerModule, NumericTextBoxModule
    , TextAreaModule, ButtonModule, AsyncPipe]
})

export class LicenseGridEditorComponent {

  // -------------- Input/Outputs --------------------------------------------

  @Input() public set dataItem(item: License | null | undefined) {

    // Clear and update the form
    this.editForm.reset(item);

    // toggle the Dialog visibility
    this.active = !!(item);
  }

  @Input() public set isReadOnly(item: boolean) {
    if (item) {
      this.editForm.disable();
      this.isReadOnlyCustomControl = true;
    }
    else {
      this.editForm.enable();
      this.isReadOnlyCustomControl = false;
    }
  }

  @Input() public isNew?: boolean;
  @Input() public companies?: Company[] | null = null;
  @Input() public showOneSysSettings?: boolean | null = true;

  @Output() cancel: EventEmitter<undefined> = new EventEmitter();
  @Output() save: EventEmitter<License> = new EventEmitter();

  /*-------------------------- public properties / methods --------------------*/

  public active: boolean = false;

  protected isReadOnlyCustomControl = true;

  protected editForm: FormGroup = new FormGroup({
    id: new FormControl()
    , name: new FormControl("", Validators.required)
    , companyId: new FormControl(Validators.required)
    , extLicenseId: new FormControl()
    , description: new FormControl()
    , startDate: new FormControl(this.dataItem?.startDate)
    , endDate: new FormControl()
    , isActive: new FormControl()
    , enforceEndDate: new FormControl()
    , maxUsers: new FormControl()
    , enforceUsers: new FormControl()
    , homePage: new FormControl()
    , osProjectId: new FormControl()
    , osProjectNumber: new FormControl()
    , osProjectName: new FormControl()
    , osContractId: new FormControl()
    , osOpportunityId: new FormControl()
    , lastModifiedOn: new FormControl()
    , lastModifiedByName: new FormControl()
  });

  /*-------------------------- Constructor  --------------------------*/

  constructor(public afUiWin: UiWindowService) { }

  /*--------------------------- event handlers  --------------------------*/

  public onSave(e: PointerEvent): void {
    e.preventDefault();

    this.save.emit(this.editForm.value);
    this.active = false;
  }

  public onCancel(e: PointerEvent): void {
    e.preventDefault();

    this.closeForm();
  }

  /*--------------------------- internal functions  --------------------------*/

  protected closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }
}
